import { FC } from 'react';
import BasePaper from '../ui/BasePaper';
import BaseTitle from '../ui/BaseTitle';
import { Storefront } from '@mui/icons-material';
import '@/styles/components/store/StoreManagement.scss';
import StoreAutocomplete from '@/components/store/StoreAutocomplete';
import { useTranslation } from 'react-i18next';

interface StoreManagementProps {
    storeId: number | null;
    onStoreChange: (storeId: number) => void;
}

const StoreManagement: FC<StoreManagementProps> = ({ storeId, onStoreChange }) => {
    const { t } = useTranslation('common');

    return (
        <BasePaper isFullHeight={false} className="store-management-container">
            <BaseTitle icon={<Storefront />} title={t('Store Management')} />
            <StoreAutocomplete storeId={storeId} onStoreChange={onStoreChange} />
        </BasePaper>
    );
};

export default StoreManagement;
